import FormControlLabel from '@material-ui/core/FormControlLabel'
import Radio from '@material-ui/core/Radio'
import { withStyles, WithStyles } from '@material-ui/core/styles'
import createStyles from '@material-ui/core/styles/createStyles'
import upperFirst from 'lodash/upperFirst'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { AgencySettings_EnabledFeaturesEnum } from 'src/api/gen'
import { useCheckEnabledFeature } from 'src/layout/AgencySettings'
import { Heatmap } from 'src/pages/Trips/constants'

const styles = () =>
  createStyles({
    radioButtons: {
      display: 'flex',
      justifyContent: 'space-around',
    },
    formControlRoot: {
      margin: 0,
    },
    formControlLabel: {
      fontSize: 13,
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
  })

interface ILegendProps extends WithStyles<typeof styles> {
  onToggleCheck: (checked: Heatmap) => void
  selectedHeatmap: Heatmap
}

const LegendRadioButtons = (props: ILegendProps) => {
  const { classes, selectedHeatmap, onToggleCheck } = props

  const { t } = useTranslation()

  const isTripsHeatmapEnabled = useCheckEnabledFeature()(AgencySettings_EnabledFeaturesEnum.heatmap_trips)

  return (
    <div className={classes.radioButtons}>
      <FormControlLabel
        key={Heatmap.Origin}
        label={upperFirst(t('trips.heatmap.origins'))}
        classes={{
          root: classes.formControlRoot,
          label: classes.formControlLabel,
        }}
        control={
          <Radio
            color="primary"
            onClick={() => onToggleCheck(Heatmap.Origin)}
            checked={selectedHeatmap === Heatmap.Origin}
          />
        }
      />
      <FormControlLabel
        key={Heatmap.Destination}
        label={upperFirst(t('trips.heatmap.destinations'))}
        classes={{
          root: classes.formControlRoot,
          label: classes.formControlLabel,
        }}
        control={
          <Radio
            color="primary"
            onClick={() => onToggleCheck(Heatmap.Destination)}
            checked={selectedHeatmap === Heatmap.Destination}
          />
        }
      />
      {isTripsHeatmapEnabled && (
        <FormControlLabel
          key={Heatmap.Trips}
          label={upperFirst(t('trips.heatmap.trips'))}
          classes={{
            root: classes.formControlRoot,
            label: classes.formControlLabel,
          }}
          control={
            <Radio
              color="primary"
              onClick={() => onToggleCheck(Heatmap.Trips)}
              checked={selectedHeatmap === Heatmap.Trips}
            />
          }
        />
      )}
    </div>
  )
}

export default withStyles(styles)(LegendRadioButtons)
